<template>
  <f7-page name="asset-position">
    <!-- Top Navbar -->
    <f7-progressbar v-if="isLoading" infinite color="green" class="progressbar-top"></f7-progressbar>
    <f7-navbar :sliding="false">
      <f7-nav-left back-link="Back">
      </f7-nav-left>
      <f7-nav-title sliding>{{ pageTitle }}</f7-nav-title>
      <f7-nav-right>
        <f7-link :href="`/assets/last-alarms/?id=${f7route.query.id}&name=${f7route.query.name}`" icon="f7-icons icon-notification"></f7-link>
        <f7-link @click="getAssetLocation" href="#" icon-f7="arrow_2_circlepath"></f7-link>
      </f7-nav-right>
    </f7-navbar>

    <!--<f7-toolbar bottom class="custom-toolbar bg-color-white" key="sim-bottom-toolbar-key">
      <div class="row width-100 padding-horizontal">
        <f7-button @click="ForceReconnect" color="green" fill class="col" >{{ $t('ForceReconnect') }}</f7-button>
       </div>
    </f7-toolbar>-->
    <!--<f7-toolbar v-if="!isIncorrectData" bottom no-shadow >
      <div class="row width-100 list no-margin no-hairlines no-hairlines-between">
        <label class="item-radio item-content color-gray padding-left disabled">
          <input type="radio" name="radio-geolock" value="off" checked />
          <i class="icon icon-radio margin-right-half"></i>
          <div class="item-inner">
            <div class="item-title text-color-gray">{{ $t('COM_MSG016') }}</div>
          </div>
        </label>
        <div class="item-content no-padding-left">
          <div class="item-title text-color-black">{{ $t('ASSET_POSITION_MSG008') }}</div>
        </div>
        <label class="item-radio item-content color-red flex-direction-row-reverse disabled">
          <input type="radio" name="radio-geolock" value="on"  />
          <i class="icon icon-radio margin-right"></i>
          <div class="item-inner">
            <div class="item-title text-color-red">{{ $t('COM_MSG015') }}</div>
          </div>
        </label>
      </div>
    </f7-toolbar>-->

    <div class="map-wrapper">
      <l-map
          ref="map"
          :zoom="zoom"
          :center="center"
          style="height: 100%"
          :options="{zoomControl: false, tap: false, preferCanvas: true}"
      >
        <l-control-layers position="topright"  ></l-control-layers>
        <l-tile-layer
            v-for="tileProvider in tileProviders"
            :key="tileProvider.name"
            :name="tileProvider.name"
            :visible="tileProvider.visible"
            :url="tileProvider.url"
            :subdomains="tileProvider.subdomains"
            layer-type="base"/>

        <l-marker
            v-if="markerLatLng.length"
            :lat-lng="markerLatLng"
            :icon="markerIcon"
        >
          <!--<l-icon :icon-url="iconUrl" :icon-size="[40,40]" :icon-anchor="[20, 39]" />-->

          <l-popup>
            <table cellpadding="0" cellspacing="0" border="0" class="marker-data-table">
              <tbody>
              <tr>
                <td class="marker-data-caption">{{ $t('Name') }}</td>
                <td class="marker-data-value">{{ f7route.query.name }}</td>
              </tr>
              <tr>
                <td class="marker-data-caption">{{ $t('PositionTime') }}</td>
                <td class="marker-data-value">{{ dateFormat(mapPopupData.DateTime+'+0000', 'datetime') }}</td>
              </tr>
              <!--<tr>
                <td class="marker-data-caption">{{ $t('Mileage') }}</td>
                <td class="marker-data-value">{{ mapPopupData.mileage }} {{ mileageUnit }}</td>
              </tr>-->
              <tr>
                <td class="marker-data-caption">{{ $t('Speed') }}</td>
                <td class="marker-data-value">{{ mapPopupData.Speed }} {{ speedUnit }}</td>
              </tr>
              <tr>
                <td class="marker-data-caption">{{ $t('Direction') }}</td>
                <td class="marker-data-value">{{ directionFormat(mapPopupData.Direct) }}</td>
              </tr>
              <tr>
                <td class="marker-data-caption">{{ $t('GPS') }}</td>
                <td class="marker-data-value marker-address asset-address">{{ parseFloat(mapPopupData.Lat).toFixed(4) }}, {{ parseFloat(mapPopupData.Lng).toFixed(4) }}</td>
              </tr>
              <tr>
                <td class="marker-data-caption">{{ $t('Address') }}</td>
                <td class="marker-data-value marker-address asset-address">{{ customAddress ? customAddress : $t('Loading') }}</td>
              </tr>
              </tbody>
            </table>
          </l-popup>
        </l-marker>

      </l-map>
    </div>
  </f7-page>

</template>

<script>
import L from 'leaflet';
import { LMap, LTileLayer, LMarker, LControlLayers, LPopup } from "@vue-leaflet/vue-leaflet";
import {mapGetters} from "vuex";
import { f7 } from 'framework7-vue';
import { dateFormat, directionText } from "../../js/helpers";
import { QTAPI } from "../../services/qt-api"

export default {
  name: "asset-position",
  components: {
    LMap, LTileLayer, LMarker, LControlLayers, LPopup
  },

  props: {
    f7router: Object,
    f7route: Object,
  },

  computed: {
    ...mapGetters(['MinorToken'])
  },

  data: function(){

    return {
      pageTitle: this.$t('LastUpdate'),
      isLoading: false,
      isIncorrectData: false,

      zoom: 9,
      center: L.latLng(47.41322, -1.219482),
      map: '',

      tileProviders: [
        {
          name: 'Map',
          visible: true,
          url: 'https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',
          //subdomains: ['mt0','mt1','mt2','mt3']
          subdomains: ['mt0','mt1','mt2','mt3']
        },
        {
          name: 'OpenStreetMap',
          visible: false,
          url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        },
        {
          name: 'Satelitte',
          visible: false,
          url: 'https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}',
          subdomains: ['mt0','mt1','mt2','mt3']
        },
      ],

      markerIcon: L.icon({
        iconUrl: './static/images/map-marker.svg',
        iconSize:     [40, 40], // size of the icon
        iconAnchor:   [20, 39], // point of the icon which will correspond to marker's location
        popupAnchor:  [0, -40] // point from which the popup should open relative to the iconAnchor
      }),
      markerLatLng: [],
      mapPopupData: {},
      mileageUnit: 'km',
      speedUnit: 'km/h',
      //assetName: f7.views.main.router.currentRoute.query.name,
      customAddress: ''
    }
  },

  async mounted() {
    if(this.f7route.query.imei){
      this.getAssetLocation()
    }
  },

  methods: {
    directionFormat(direction){
      return directionText(direction) + `(${direction}°)`
    },
    dateFormat(...options){
      return dateFormat(...options)
    },
    async ForceReconnect() {
      this.isLoading = true
      const response = await QTAPI.ForceReconnect({
        IMSIs: this.f7route.query.imsi
      })
      this.isLoading = false
      if (!response) {
        f7.dialog.alert(this.$t('NoLocationData'), this.$t('Error'))
        return
      }
      f7.dialog.alert(this.$t('SimConnectionRefreshed'), this.$t('Success'))
    },
    async getAssetLocation() {
      this.isLoading = true
      const response = await QTAPI.GetAssetLocation({
        MinorToken: this.MinorToken,
        IMEI: this.f7route.query.imei
      })
      this.isLoading = false
      if (!response || !response.Lat || !response.Lng) {
        f7.dialog.alert(this.$t('NoLocationData'), this.$t('Error'))
        this.isIncorrectData = true
        return
      }
      this.isIncorrectData = false

      let prevCoords = {
        Lat: this.mapPopupData.Lat,
        Lng: this.mapPopupData.Lng,
      }
      this.mapPopupData = response
      if (prevCoords.Lat !== response.Lat || prevCoords.Lng !== response.Lng){
        this.getAddress({Lat: response.Lat, Lng: response.Lng})
      }
      this.center = [response.Lat, response.Lng]
      this.markerLatLng = [response.Lat, response.Lng]
    },
    async getAddress(coords){
      const response = await QTAPI.GetAddressByCoords({
        latitude: coords.Lat,
        longitude: coords.Lng
      })
      if (!response) {
        return
      }
      this.customAddress = response.display_name
    },
  }
}
</script>

<style scoped lang="scss">

</style>